export enum MyDataSyncStatus {
None,
SubmitInvoice,
SubmitClassifications,
FillClassifications,
CompleteInvoice,
}
